"use strict";

var _authors = _interopRequireDefault(require("../components/authors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Authors
 * -----------------------------------------------------------------------------
 * Scripts to execute on the authors page.
 *
 */


document.addEventListener('DOMContentLoaded', function () {
  (0, _authors["default"])().init();
});